<template>
  <component :is="dial"></component>
</template>

<script>
import dials from '@/components/parts/dials';

export default {
  name: 'sdDial',
  props: ['data'],
  components: {
    ...dials,
  },
  data() {
    return {
      dials,
    };
  },
  computed: {
    dial() {
      if (this.data) {
        return this.dials[this.data.parent];
      }
    },
  },
};
</script>
